import * as y from 'yup'

/** @param {import("react-i18next").TFunction} t */
export const generateSchema = (t) => {
  return {
    goodsGroup: y.object({
      code: y
        .string()
        .required(t('Required'))
        .max(100, 'Mã nhóm hàng hóa, dịch vụ tối đa 100 ký tự'),

      name: y
        .string()
        .required(t('Required'))
        .max(300, 'Tên nhóm hàng hóa, dịch vụ tối đa 300 ký tự'),
    }),
  }
}
